package ru.villawonka.app.domain.model

enum class SortTypeDomain {
    NEWEST,
    HIGH_PRICE,
    LOW_PRICE,
}